import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import Swal from "sweetalert2";

import { FaList, FaSyncAlt } from "react-icons/fa";
import socket from "../../../context/socket";
import _ from "lodash";
import { useLocation } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import { moneyFormatIndia } from "../../../utils/inputsValidation";

const SIPCalculator = ({
  isGetClientGoal,
  allExternalFolios,
  currentGoal,
  activeTab
}) => {
  console.log("currentGoal", currentGoal);

  const roomId = new URLSearchParams(useLocation().search).get("clientId");
  const [isProjection, setIsProjection] = useState([]);
  const [initialValues, setInitialValues] = useState({});

  const currentYear = new Date().getFullYear(); // Automatically set start year
  const [targetAmount, setTargetAmount] = useState(0);
  const [planOTILabel, setplanOTILabel] = useState(null);
  const [targetYear, setTargetYear] = useState(0);
  const [monthlySIP, setMonthlySIP] = useState(0);
  const [annualStepUp, setAnnualStepUp] = useState(0); // Default ₹500 Step-Up Amount
  const [portfolioType, setPortfoliotype] = useState(null); // Default ₹500 Step-Up Amount
  const [isResetting, setIsResetting] = useState(false);
  const [projectionAmount, setProjectionAmount] = useState(""); // Default ₹500 Step-Up Amount


  const [annualReturn, setAnnualReturn] = useState(0);
  const [oneTimeInvestment, setOneTimeInvestment] = useState(0);
  const [accumulatedAmount, setAccumulatedAmount] = useState(0);
  const [delayYears, setDelayYears] = useState(0);
  const [inflationRate, setInflationRate] = useState(0); // Default 5% Inflation
  const [impact, setImpact] = useState(0);
  const [chartData, setChartData] = useState({ series: [], options: {} });
  console.log('setChartData', chartData);
  console.log('Monthly-Sip', chartData);


  const [numberOfLabels, setNumberOfLabels] = useState(12);

  const xAxisCategories = useMemo(() => {
    if (!currentGoal?.timeline || !currentGoal?.startYear) return [];

    const timelineInMonths = currentGoal.timeline * 12;
    const startYear = Number(currentGoal.startYear);
    const totalPoints = timelineInMonths + 12;

    if (timelineInMonths < numberOfLabels * 12) {
      return Array.from({ length: totalPoints }, (_, i) =>
        i % 12 === 0 ? (startYear + Math.floor(i / 12)).toString() : ""
      );
    }

    const interval = Math.floor(totalPoints / numberOfLabels);

    return Array.from({ length: totalPoints }, (_, i) =>
      i % interval === 0 ? (startYear + Math.floor(i / 12)).toString() : ""
    );
  }, [currentGoal?.timeline, currentGoal?.startYear, numberOfLabels]);


  const handleNumberInput = (setter) => (e) => {
    const value = e.target.value;

    // Remove leading zeros (except if it's just "0")
    const cleanedValue = value === "0" ? "0" : value.replace(/^0+/, "");

    const numberValue = Number(cleanedValue);

    setter(isNaN(numberValue) ? 0 : numberValue);
  };

  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);


  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      socket.emit("message_to", {
        room: roomId,
        data: {
          annualReturn,
          oneTimeInvestment,
          delayYears,
          inflationRate,
          impact,
          monthlySIP,
          annualStepUp,
        },
      });

    }, 300),
    [annualReturn, oneTimeInvestment, delayYears, inflationRate, impact]
  );

  const getMonthlySIP = () => {
    const { runningSIP, monthlysaving } = currentGoal || {};
    const { scenarioMonthSaving } = isGetClientGoal || {};

    if (runningSIP || monthlysaving) {
      // return runningSIP || monthlysaving;
      return runningSIP;
    }

    if (scenarioMonthSaving) {
      // console.log("Using scenarioMonthSaving:", scenarioMonthSaving);
      return scenarioMonthSaving;
    }

    // console.log("No SIP found. currentGoal:", currentGoal);
    return 0;
  };

  useEffect(() => {
    debouncedEmitMessage();

    // console.log("annualReturn",annualReturn,oneTimeInvestment);
  }, [annualReturn, oneTimeInvestment, delayYears, inflationRate, impact]);

  useEffect(() => {
    // console.log("getMonthlySIP", Number(getMonthlySIP()));

    if (isGetClientGoal) {
      const initialData = {
        targetAmount: Number(isGetClientGoal?.TargetAmount || 0),
        annualReturn: Number(isGetClientGoal?.expectedReturn || 0),
        targetYear: Number(isGetClientGoal?.goalYear || 0),
        monthlySIP: Number(
          currentGoal?.runningSIP ?? isGetClientGoal?.scenarioMonthSaving ?? 0
        ),

        inflationRate: Number(isGetClientGoal?.inflation || 0),
        annualStepUp: 0,
        oneTimeInvestment: 0,
        delayYears: 0,
      };
      // handleReset();
      setInitialValues(initialData);

      setOneTimeInvestment(0)
      setTargetAmount(Number(isGetClientGoal?.TargetAmount));
      setAnnualReturn(Number(isGetClientGoal?.expectedReturn));
      setTargetYear(Number(isGetClientGoal?.goalYear));
      setMonthlySIP(Number(getMonthlySIP()));
      setInflationRate(Number(isGetClientGoal?.inflation));
      setplanOTILabel(isGetClientGoal?.planOTILabel);
      setAccumulatedAmount(currentGoal?.accumulatedAmount);
      if (currentGoal?.accumulatedAmount > 0) {
        setOneTimeInvestment(currentGoal?.accumulatedAmount);
      }

      // setTargetAmount(isGetClientGoal?.TargetAmount);
      // setAnnualReturn(isGetClientGoal?.expectedReturn);
      // setTargetYear(isGetClientGoal?.goalYear);
      // setMonthlySIP(isGetClientGoal?.scenarioMonthSaving);
      // setInflationRate(isGetClientGoal?.inflation);
    }
  }, [isGetClientGoal, currentGoal]);

  const handleReset = () => {
    // console.log("getMonthlySIP", Number(getMonthlySIP()));
    setIsResetting(true); // Start spinning
    setTimeout(() => {
      setIsResetting(false); // Stop spinning after 1s
    }, 250);
    setTargetAmount(initialValues.targetAmount);
    setAnnualReturn(initialValues.annualReturn);
    setTargetYear(initialValues.targetYear);
    setMonthlySIP(Number(getMonthlySIP()));
    setInflationRate(initialValues.inflationRate);
    setAnnualStepUp(initialValues.annualStepUp);

    setDelayYears(initialValues.delayYears);
    setAccumulatedAmount(currentGoal?.accumulatedAmount);

    if (currentGoal?.accumulatedAmount > 0) {
      setOneTimeInvestment(currentGoal?.accumulatedAmount);
    } else {
      setOneTimeInvestment(0)
    }
  };

  const checkActiveDelay = () => {
    console.log("checkActiveDelay", currentGoal?.startYear, currentYear);
    if (currentGoal?.startYear == currentYear) {
      return false;
    }
    return true;
  };


  useEffect(() => {
    if (targetYear != 0) {
      if (targetYear <= currentYear) {
        console.log("i m returning");
        return; // Prevent invalid years
      }
      if (delayYears > 0 && delayYears >= targetYear - currentYear) {
        console.log("i m returning2");

        Swal.fire({
          icon: "error",
          title: "Invalid Delay",
          text: "Delay cannot be greater than or equal to the Target Year!",
        });
        setDelayYears(0); // Reset the delay to 0 to prevent errors
      } else {
        console.log("i m returning3");

        // calculateGrowth();
        // calculateGrowthNew(currentGoal);
      }
    }

    let portfolio = "";
    if (annualReturn <= 5) {
      portfolio = "Ultra Conservative";
    } else if (annualReturn > 5 && annualReturn <= 8) {
      portfolio = "Conservative";
    } else if (annualReturn > 8 && annualReturn <= 10) {
      portfolio = "Moderate";
    } else if (annualReturn > 10 && annualReturn <= 12) {
      portfolio = "Aggressive";
    } else if (annualReturn > 12) {
      portfolio = "Very Aggressive";
    }
    setPortfoliotype(portfolio);
    console.log('t3', targetAmount,
      targetYear,
      monthlySIP,
      annualReturn,
      oneTimeInvestment,
      delayYears,
      inflationRate,
      annualStepUp,);
  }, [
    targetAmount,
    targetYear,
    monthlySIP,
    annualReturn,
    oneTimeInvestment,
    delayYears,
    inflationRate,
    annualStepUp, // 🔥 Now it updates when step-up changes
  ]);

  useEffect(() => {
    if (isGetClientGoal) {
      isGetClientGoal.scenarioMonthSaving = monthlySIP;
      isGetClientGoal.annualStepUp = annualStepUp;
    }
  }, [monthlySIP, annualStepUp, isGetClientGoal]);

  const formatAmount = (amount) => {
    if (!amount) return "0";

    const absAmount = Math.abs(amount); // Handle negative values properly

    if (absAmount >= 10000000) {
      return (amount / 10000000).toFixed(2) + " Cr"; // Convert to Crores
    } else if (absAmount >= 100000) {
      return (amount / 100000).toFixed(2) + " L"; // Convert to Lakhs
    } else if (absAmount >= 1000) {
      return (amount / 1000).toFixed(2) + " K"; // Convert to Thousands
    } else {
      return amount.toLocaleString("en-IN"); // Default format with commas
    }
  };

  function useDebouncedEffect(fn, deps, delay = 300) {
    useEffect(() => {
      const id = setTimeout(fn, delay);
      return () => clearTimeout(id);
    }, [...deps, delay]);
  }

  useEffect(() => {
    const portfolio =
      annualReturn <= 5
        ? "Ultra Conservative"
        : annualReturn <= 8
          ? "Conservative"
          : annualReturn <= 10
            ? "Moderate"
            : annualReturn <= 12
              ? "Aggressive"
              : "Very Aggressive";

    setPortfoliotype(portfolio);
  }, [annualReturn, setPortfoliotype]);

  // Prevent repeated SweetAlerts while user is typing
  const warnedRef = useRef(false);

  // Debounced compute
  useDebouncedEffect(() => {
    // Coerce to numbers & sane defaults
    const tAmt = Number(targetAmount) || 0;
    const tYear = Number(targetYear) || 0;
    const mSIP = Number(monthlySIP) || 0;
    const ret = Number(annualReturn) || 0;
    const lump = Number(oneTimeInvestment) || 0;
    const dYrs = Number(delayYears) || 0;
    const infl = Number(inflationRate) || 0;
    const step = Number(annualStepUp) || 0;

    // Basic guards
    if (!tYear) return; // nothing to do until user picks a target year

    // Validate years
    if (tYear <= currentYear) {
      // target year can't be in past/current
      // return;  //commented on 16-08-2024 because   calculateGrowthNew 8587 senario chart error
    }

    const diffYears = tYear - currentYear;

    // Delay cannot consume/meet target year window
    if (dYrs > 0 && dYrs >= diffYears) {
      if (!warnedRef.current) {
        warnedRef.current = true;
        Swal.fire({
          icon: "error",
          title: "Invalid Delay",
          text: "Delay cannot be greater than or equal to the Target Year!",
        }).then(() => {
          warnedRef.current = false;
        });
      }
      setDelayYears(0);
      return;
    }

    // All good → run calc
    calculateGrowthNew(currentGoal);
  }, [
    targetAmount,
    targetYear,
    monthlySIP,
    annualReturn,
    oneTimeInvestment,
    delayYears,
    inflationRate,
    annualStepUp,
    currentGoal,      // include goal if it affects calculation
    currentYear,      // keep consistent if it can change
  ]);
  const calculateGrowthNew = (currentGoal) => {
    // console.log("currentGoal", currentGoal);
    const currentTime = new Date();
    let staticTargetYear = Number(currentGoal?.targetYear);
    let staticStartYear = Number(currentGoal?.startYear);
    // let staticSIP = currentGoal?.monthlysaving;

    let staticSIP = calculateMonthlySIP(
      currentGoal.targetAmount,
      currentGoal.targetReturn,
      currentGoal.timeline
    );

    // console.log('staticSIP78787', staticSIP, currentGoal.targetAmount, currentGoal.targetReturn, currentGoal.timeline)
    let staticTargetAmount = currentGoal?.targetAmount;
    let staticCAGR = isGetClientGoal?.expectedReturn;
    let remainingMonths = Number(isGetClientGoal?.yearsRemain) * 12;
    let cagr = annualReturn;
    let monthEndValue = 0;
    let monthEndValue1 = 0;
    let capitalGrowth = 0;
    let capitalGrowth1 = 0;
    let finalCorpus1 = 0;
    let finalCorpus2 = 0;
    let line1ChartValues = [];
    let line2ChartValues = [];
    let currentBalance = accumulatedAmount;
    let currentRunningSIP = currentGoal?.runningSIP;
    let sip = monthlySIP;

    let myYear = (staticTargetYear - staticStartYear) * 12;
    let inititaltotalMonth = myYear;
    // let remainingMonths = myYear;
    // if (staticStartYear != currentTime.getFullYear())
    //   staticSIP = (staticTargetAmount * (staticCAGR / 1200)) / (Math.pow(1 + staticCAGR / 1200, myYear) - 1);

    if (targetYear != currentTime.getFullYear())
      staticSIP =
        (targetAmount * (staticCAGR / 1200)) /
        (Math.pow(1 + staticCAGR / 1200, myYear) - 1);

    // console.log('staticSIP111111144', staticSIP)
    line1ChartValues.push(staticSIP);

    let startYear = staticStartYear;
    startYear = Number(startYear) + Number(delayYears);
    if (delayYears > 0) {
      startYear = Number(staticStartYear) + Number(delayYears);
    }
    const adjustedStartYear = Number(currentYear) + Number(delayYears);
    let yearLabels = [adjustedStartYear];

    let plantotalMonth = (targetYear - startYear) * 12;
    // console.log("plantotalMonth", plantotalMonth);
    let year = currentTime.getFullYear();
    let test1 = (staticTargetYear - year) * 12;

    let oneTimeInvFutureVal =
      oneTimeInvestment * Math.pow(1 + cagr / 100, staticTargetYear - year);

    // console.log("remainingMonths89", remainingMonths);
    if (currentBalance == "0" && currentRunningSIP == "0") {
      if (!Number.isFinite(remainingMonths) || remainingMonths <= 0) return;
      for (var i = 1; i < remainingMonths; i++) {
        if (i > Number(inititaltotalMonth) - Number(plantotalMonth)) {
          capitalGrowth =
            ((Number(monthEndValue) + Number(sip)) * Number(cagr)) / 1200;
          monthEndValue =
            Number(monthEndValue) + Number(capitalGrowth) + Number(sip);
        }
      }
      // console.log("am89", monthEndValue, sip);
    } else {
      if (!Number.isFinite(inititaltotalMonth) || inititaltotalMonth <= 0) return;
      for (var i = 1; i < test1; i++) {
        if (i > Number(inititaltotalMonth) - Number(plantotalMonth)) {
          capitalGrowth =
            ((Number(monthEndValue) + Number(sip)) * Number(cagr)) / 1200;
          monthEndValue =
            Number(monthEndValue) + Number(capitalGrowth) + Number(sip);
        }
      }
    }

    monthEndValue = Number(monthEndValue) + Number(sip);

    finalCorpus1 = Math.round(monthEndValue);

    if (oneTimeInvestment != 0) {
      monthEndValue = 0;
      finalCorpus1 = finalCorpus1 + oneTimeInvFutureVal;
      sip =
        (finalCorpus1 * (cagr / 1200)) /
        (Math.pow(1 + cagr / 1200, plantotalMonth) - 1);
      for (var i = 1; i < myYear; i++) {
        if (i > Number(inititaltotalMonth) - Number(plantotalMonth)) {
          capitalGrowth =
            ((Number(monthEndValue) + Number(sip)) * Number(cagr)) / 1200;
          monthEndValue =
            Number(monthEndValue) + Number(capitalGrowth) + Number(sip);
          // if (i > 56) {
          // console.log("xdr4", monthEndValue);
          // }
          // line2ChartValues.push(Math.round(monthEndValue));
          line2ChartValues[i] = Math.round(monthEndValue);
        } else {
          // line2ChartValues.push(null);
          line2ChartValues[i] = null;
        }
      }
      monthEndValue = monthEndValue + sip;
      finalCorpus1 = Math.round(monthEndValue);
    }

    if (currentBalance == "0" && currentRunningSIP == "0") {
      if (staticStartYear != currentTime.getFullYear())
        sip =
          (finalCorpus1 * (cagr / 1200)) /
          (Math.pow(
            1 + cagr / 1200,
            (staticTargetYear - staticStartYear) * 12
          ) -
            1);

      // console.log(
      //   `finalCorpus1: ${finalCorpus1}, cagr: ${cagr}, startYear: ${startYear}, targetYear: ${targetYear}, months: ${(targetYear - startYear) * 12
      //   }, SIP: ${sip}`
      // );
    } else {
      if (staticStartYear != currentTime.getFullYear())
        sip =
          (finalCorpus1 * (cagr / 1200)) /
          (Math.pow(1 + cagr / 1200, myYear) - 1);
    }
    var monthsLeft = (staticTargetYear - currentTime.getFullYear()) * 12;
    // //////////////////////////////////////////////////////////////////
    // // var clientIdNew = '<?php //echo $client_id; ?>';
    // // if(clientIdNew==3671)
    // // {

    // console.log("monthsLeftss", monthsLeft);
    monthEndValue = 0;
    capitalGrowth = 0;
    finalCorpus1 = 0;
    let sipStepUp = 0;
    for (var i = 1; i < monthsLeft; i++) {
      if (annualStepUp != "" && annualStepUp != 0) {
        if (i % 12 == 1 && i != 1) {
          sipStepUp = sipStepUp + parseInt(annualStepUp);
        }
      }

      capitalGrowth = ((monthEndValue + sipStepUp) * cagr) / 1200;
      monthEndValue = monthEndValue + capitalGrowth + sipStepUp;

      // console.log(
      //   `Month ${i}: Stepup = ${sipStepUp}, Growth = ${capitalGrowth}, MonthEndValue = ${monthEndValue}, cagr = ${cagr}`
      // );
    }
    monthEndValue = Number(monthEndValue) + Number(sipStepUp);
    finalCorpus1 = monthEndValue;

    sip =
      (Number(finalCorpus1) * (Number(cagr) / 1200)) /
      (Math.pow(1 + Number(cagr) / 1200, Number(myYear)) - 1) +
      Number(sip);

    // }
    // // }
    // //////////////////////////////////////////////////////////////////
    monthEndValue = 0;
    monthEndValue1 = 0;
    capitalGrowth = 0;
    capitalGrowth1 = 0;
    finalCorpus1 = 0;
    finalCorpus2 = 0;
    line2ChartValues.unshift(parseInt(sip));

    for (var i = 1; i < inititaltotalMonth; i++) {
      if (i > Number(inititaltotalMonth) - Number(plantotalMonth)) {
        capitalGrowth =
          ((Number(monthEndValue) + Number(sip)) * Number(cagr)) / 1200;

        monthEndValue =
          Number(monthEndValue) + Number(capitalGrowth) + Number(sip);

        // console.log("line2ChartValues789", sip);
        // console.log("monthEndValue-final", monthEndValue, i);
        // line2ChartValues.push(Math.round(monthEndValue));
        line2ChartValues[i] = Math.round(monthEndValue);
      } else {
        // line2ChartValues.push(null);
        line2ChartValues[i] = null;
      }
    }

    // console.log("line2ChartValues789", line2ChartValues);
    monthEndValue = Number(monthEndValue) + sip;
    finalCorpus1 = Math.round(monthEndValue);
    let lineChartLabel = [];
    lineChartLabel.push(staticStartYear + "");
    for (var i = 1; i < inititaltotalMonth; i++) {
      console.log('staticSIP', staticSIP)
      capitalGrowth1 = ((monthEndValue1 + staticSIP) * staticCAGR) / 1200;
      monthEndValue1 = monthEndValue1 + capitalGrowth1 + staticSIP;
      line1ChartValues.push(Math.round(monthEndValue1));
      if (i % 12 == 0) {
        lineChartLabel.push(parseInt(lineChartLabel[0]) + i / 12 + "");
      } else lineChartLabel.push("");
    }
    lineChartLabel[inititaltotalMonth] = staticTargetYear + "";
    monthEndValue1 = monthEndValue1 + staticSIP;
    finalCorpus2 = Math.round(monthEndValue1);
    console.log('finalCorpus2', line1ChartValues)
    line1ChartValues[inititaltotalMonth] = finalCorpus2;
    line2ChartValues[inititaltotalMonth] = finalCorpus1;
    lineChartLabel = lineChartLabel.slice(0, inititaltotalMonth + 1);
    line1ChartValues = line1ChartValues.slice(0, inititaltotalMonth + 1);
    line2ChartValues = line2ChartValues.slice(0, inititaltotalMonth + 1);
    // data3.labels = lineChartLabel;
    let lineData1 = [];
    let lineData2 = [];

    const fullStartYear = staticStartYear; // e.g. 2024
    for (let i = 0; i < Math.min(line1ChartValues.length, inititaltotalMonth + 1); i++) {
      const d = new Date(fullStartYear, i, 1);
      const isoDate = isNaN(d) ? "" : d.toISOString().split("T")[0];

      lineData1.push({ x: isoDate, y: line1ChartValues[i] ?? 0 });
      lineData2.push({ x: isoDate, y: line2ChartValues[i] ?? 0 });
    }

    lineData1 = lineData1.slice(0, inititaltotalMonth + 1);
    lineData2 = lineData2.slice(0, inititaltotalMonth + 1);
    // delayBetweenPoints = 500 / lineData1.length;
    // config3.options.animation.y.duration = delayBetweenPoints;
    // data3.datasets[0].data = lineData1;
    // data3.datasets[1].data = lineData2;

    console.log("lineData1", lineData1, targetAmount,
      targetYear,
      monthlySIP,
      annualReturn,
      oneTimeInvestment,
      delayYears,
      inflationRate,
      annualStepUp);
    console.log("lineData2", lineData2);

    // console.log("lineData1", line1ChartValues); //this is Taret growth
    // console.log("lineData2", line2ChartValues); //this is sip growth

    setImpact(
      line2ChartValues[line2ChartValues.length - 1] -
      line1ChartValues[line1ChartValues.length - 1]
    ); // Calculate Impact

    // console.log("sipGrowth", line2ChartValues);
    setProjectionAmount(line2ChartValues[line2ChartValues.length - 1]);

    const xAxisLabels = Array.from(
      { length: inititaltotalMonth + 1 },
      (_, i) => {
        return i % 12 === 0 ? `${startYear + Math.floor(i / 12)}` : "";
      }
    );

    setChartData({
      series: [
        {
          name: "SIP Growth",
          data: line2ChartValues,
          color: "#B3B3B3",
          type: "line",
        },
        {
          name: "Target Amount",
          data: line1ChartValues,
          color: "#52B58C",
          type: "area",
        },
      ],

      options: {
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            const dataIndex = opts.dataPointIndex;
            const seriesIndex = opts.seriesIndex;
            const totalPoints = opts.w.globals.series[seriesIndex].length;
            // Only show label at last point
            if (dataIndex === totalPoints - 1) {
              return formatAmount(val);
            }
            return "";
          },
          offsetX: -10,
          offsetY: -10,
          style: {
            fontSize: "12px",
            fontWeight: "600",
            colors: ["#52B58C", "#666"], // Target: green, SIP: dark gray
          },
          background: {
            enabled: true,
            borderRadius: 4,
            padding: 4,
            foreColor: "#fff",
            color: function ({ seriesIndex }) {
              return seriesIndex === 0 ? "#666" : "#52B58C";
            },
          },
        },
        chart: {
          type: "area",
          toolbar: { show: false },
        },
        xaxis: {
          categories: xAxisCategories,
          labels: {
            style: {
              fontSize: "10px",
              color: document.body.classList.contains("dark-mode")
                ? "#fff"
                : "#000",
            },
          },
        },
        yaxis: {
          show: false, // Hide Y-axis values as requested
        },

        stroke: {
          curve: "smooth", // Smooth curve
          width: [3, 3], // Width for both lines
          dashArray: [5, 0], // Apply dashed line for SIP Growth (first series)
        },

        fill: {
          type: ["solid", "gradient"], // Solid fill for SIP Growth, gradient for Target
          gradient: {
            shadeIntensity: 0.4,
            opacityFrom: 0.7,
            opacityTo: 0.2,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            formatter: function (val) {
              const startYear = Number(lineChartLabel[0]); // e.g., 2025
              const year = startYear + Math.floor((val - 1) / 12);
              const month = ((val - 1) % 12) + 1;
              return `Year: ${year}, Month: ${month} , SIP Month : ${val}`;
            },
          },
          y: {
            formatter: formatAmount,
          },
          theme: document.body.classList.contains("dark-mode")
            ? "dark"
            : "light",
        },

        grid: { show: false },
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          labels: {
            colors: document.body.classList.contains("dark-mode")
              ? "#fff"
              : "#000", // Legend label color based on theme
          },
        },
      },
    });
  };

  return (
    <>
      {
        (!allExternalFolios && activeTab === "externalInvestment") ? <></> :
          <div>
            {/* <div className="container">
        <div className="row g-3 mb-4 mt-1">
          <div className="col-12 col-sm-6 col-md-3">
            <div className="p-3 back-clrgreen text-center rounded-2">
              <p className="txt-color-revers mb-1">Monthly SIP</p>
              <h5 className="txt-color-revers">₹ {formatAmount(monthlySIP)}</h5>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-3">
            <div className="p-3 back-clrgreen text-center rounded-2">
              <p className="txt-color-revers mb-1">Years</p>
              <h5 className="txt-color-revers">{targetYear - currentYear}</h5>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-3">
            <div className="p-3 back-clrgreen text-center rounded-2">
              <p className="txt-color-revers mb-1">Portfolio</p>
              <h5 className="txt-color-revers">{portfolioType}</h5>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-3">
            <div className="p-3 back-clrgreen text-center rounded-2">
              <p className="txt-color-revers mb-1">Expected Return</p>
              <h5 className="txt-color-revers">{annualReturn}%</h5>
            </div>
          </div>
        </div>
      </div> */}

            <h3 className="txt-color mb-4">Scenario Analysis</h3>
            <div className="row">
              {/* Impact Display */}
              <div className="col-12 col-md-5 mb-4">
                {/* Input Fields */}
                <div className="row g-3">
                  <div className="col-6 border-bottom pb-2">
                    <label className="fs-5 clrgrey">Target</label>
                  </div>
                  <div className="col-6 border-bottom pb-2">
                    <input
                      type="text"
                      class="form-control w-100 refer form-control-sm"
                      value={moneyFormatIndia(targetAmount)}
                      disabled
                    />
                  </div>

                  <div className="col-6 border-bottom pb-2">
                    <label className="fs-5 clrgrey">Target Year</label>
                  </div>
                  <div className="col-6 border-bottom pb-2">
                    <input
                      type="text"
                      className="form-control w-100 refer form-control-sm"
                      value={targetYear}
                      disabled
                    />
                  </div>

                  <div className="col-6 border-bottom pb-2">
                    <label className="fs-5 clrgrey">Assumed Inflation (%)</label>
                  </div>
                  <div className="col-6 border-bottom pb-2">
                    <input
                      type="number"
                      className="form-control w-100 refer form-control-sm"
                      value={inflationRate === 0 ? "" : inflationRate}
                      // onChange={(e) => setInflationRate(Number(e.target.value))}
                      onChange={handleNumberInput(setInflationRate)}
                      disabled
                    />
                  </div>

                  <div className="col-6 border-bottom pb-2">
                    <label className="fs-5 clrgrey">Monthly Saving</label>
                  </div>
                  <div className="col-6 border-bottom pb-2">
                    <input
                      type="number"
                      className="form-control w-100 refer form-control-sm"
                      value={monthlySIP === 0 ? "" : monthlySIP}
                      // onChange={(e) => setMonthlySIP(Number(e.target.value))}
                      onChange={handleNumberInput(setMonthlySIP)}
                    />
                  </div>

                  <div className="col-6 border-bottom pb-2">
                    <label className="fs-5 clrgrey">Annual Step-Up (₹)</label>
                  </div>
                  <div className="col-6 border-bottom pb-2">
                    <input
                      type="number"
                      className="form-control w-100 refer form-control-sm"
                      value={annualStepUp === 0 ? "" : annualStepUp}
                      // onChange={(e) => setAnnualStepUp(Number(e.target.value))}
                      onChange={handleNumberInput(setAnnualStepUp)}
                    />
                  </div>

                  <div className="col-6 border-bottom pb-2">
                    <label className="fs-5 clrgrey">Target Return (%)</label>
                  </div>
                  <div className="col-6 border-bottom pb-2">
                    <input
                      className="form-control w-100 refer form-control-sm"
                      type="number"
                      // value={annualReturn}
                      value={annualReturn === 0 ? "" : annualReturn}
                      // onChange={(e) => setAnnualReturn(Number(e.target.value))}
                      onChange={handleNumberInput(setAnnualReturn)}
                    />
                  </div>

                  <div className="col-6 border-bottom pb-2">
                    <label className="fs-5 clrgrey">Delay (Years)</label>
                  </div>
                  <div className="col-6 border-bottom pb-2">
                    <input
                      className="form-control w-100 refer form-control-sm"
                      type="number"
                      // value={delayYears}
                      value={delayYears === 0 ? "" : delayYears}
                      disabled={checkActiveDelay()}
                      // onChange={(e) => setDelayYears(Number(e.target.value))}
                      onChange={handleNumberInput(setDelayYears)}
                    />
                  </div>

                  <div className="col-6 border-bottom pb-2">
                    <label className="fs-5 clrgrey">{planOTILabel}:</label>
                  </div>
                  <div className="col-6 border-bottom pb-2">
                    <input
                      className="form-control w-100 refer form-control-sm"
                      type="number"
                      // value={oneTimeInvestment}
                      value={oneTimeInvestment > 0 ? oneTimeInvestment.toFixed() : 0}
                      // onChange={(e) => setOneTimeInvestment(Number(e.target.value))}
                      onChange={handleNumberInput(setOneTimeInvestment)}
                    />
                  </div>
                  <div className="col-12 pb-2 d-flex justify-content-end">
                    <span onClick={handleReset} style={{ cursor: "pointer" }}>
                      <FaSyncAlt
                        className={`me-2 ${isResetting ? "spin-icon" : ""}`}
                        size={18}
                        color="green"
                      />
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="col-12 col-md-7 position-relative h-100 overflow-auto"
                style={{ minHeight: "200px", maxHeight: "500px" }}
              >
                {/* Chart */}

                <Card>
                  <Card.Header className=" p-0">
                    <div className="d-flex align-items-center justify-content-end">
                      {/* <h3 className="txt-color">Scenario Analysis</h3> */}

                      <div>
                        <Card.Body>
                          <p className="impact-value mb-0">Target</p>
                          <div className="d-flex align-items-center">
                            <Card.Title className="fs-4">
                              {" "}
                              {formatAmount(targetAmount)}
                            </Card.Title>
                            <FaArrowTrendUp className="ms-2 text-success trend-icon" />
                          </div>
                        </Card.Body>
                      </div>

                      <div>
                        <Card.Body>
                          <p className="impact-value mb-0">Projection</p>
                          <div className="d-flex align-items-center">
                            <Card.Title className="fs-4">
                              {" "}
                              {formatAmount(projectionAmount)}
                            </Card.Title>
                            <FaArrowTrendUp className="ms-2 text-success trend-icon" />
                          </div>
                        </Card.Body>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body className="position-relative">
                    <Card
                      className={`impact-card ${impact >= 0 ? "increase" : "decrease"
                        }`}
                    >
                      <Card.Body>
                        <Card.Title className="fs-4 txt-color">
                          Impact
                        </Card.Title>
                        <div className="d-flex align-items-center">
                          <p className="impact-value mb-0">{formatAmount(impact)}</p>
                          {impact >= 0 ? (
                            <FaArrowTrendUp className="ms-2 text-success trend-icon" />
                          ) : (
                            <FaArrowTrendDown className="ms-2 text-danger trend-icon" />
                          )}
                        </div>
                      </Card.Body>
                    </Card>

                    <ReactApexChart
                      options={chartData.options}
                      series={chartData.series}
                      type="area"
                      height={300}
                    />

                    <div className="d-flex align-items-center">
                      <FaList
                        className="me-2 text-success fs-5"
                        style={{ color: "#23674b" }}
                        size={40}
                      />
                      <p className="mb-0 text-dark fs-6 lh-base">
                        Monthly SIP of{" "}
                        <span className="text-success fw-bold">₹{monthlySIP}</span>{" "}
                        for{" "}
                        <span className="text-success fw-bold">
                          {targetYear - currentGoal?.startYear} years
                        </span>{" "}
                        in a{" "}
                        <span className="text-success fw-bold">{portfolioType}</span>{" "}
                        portfolio with an expected return of{" "}
                        <span className="text-success fw-bold"> {annualReturn}%</span>
                        . Annual Stepup of
                        <span className="text-success fw-bold">
                          &nbsp; ₹{annualStepUp}
                        </span>{" "}
                        . Current Value of
                        <span className="text-success fw-bold">
                          {" "}
                          {formatAmount(oneTimeInvestment)}
                        </span>{" "}
                      </p>
                    </div>
                  </Card.Body>

                  {/* 
            <div className=" text-center py-3  clrliblue  position-absolute  mt-3 p-5">
              <div>
                <h3 className="fs-5 fw-semibold"> Impact 📈 </h3>
              </div>
              <div className="fs-5 text-red-600 fw-semibold">
                {formatAmount(impact)}
              </div>
            </div> */}
                </Card>
              </div>
            </div>
          </div>
      }
    </>

  );
};

export default SIPCalculator;
function calculateMonthlySIP(targetAmount, annualReturn, timelineYears) {
  const months = timelineYears * 12; // Convert years to months
  const monthlyRate = annualReturn / 12 / 100; // Convert annual return to monthly

  // Future Value Annuity Formula
  const factor = Math.pow(1 + monthlyRate, months) - 1;

  // Avoid division by zero error
  if (factor <= 0) return targetAmount / months;

  const monthlySIP = (targetAmount * monthlyRate) / factor;

  return monthlySIP;
}
